<script>
import { VAutocomplete } from 'vuetify/lib'
import VuelidateMixin from "@/components/General/Form/Mixin/VuelidateMixin";
export default {
    mixins: [VuelidateMixin],
    extends: VAutocomplete,
    props: {
        filled: {
            default: true,
            type: Boolean
        },
        hideDetails: {
            default: 'auto',
        },
        validation: {
            type: Object,
            required: false,
        }
    },
    methods: {
        /**
         * overwrite vuetify method
         * set single selects to null instead of undefined
         */
        clearableCallback () {
            this.setValue(this.multiple ? [] : null)
            this.setMenuIndex(-1)
            this.$nextTick(() => this.$refs.input && this.$refs.input.focus())

            if (this.openOnClear) this.isMenuActive = true
        },
    }
}
</script>
